

import React from 'react'
import ReactApexChart from "react-apexcharts";
export default function Graph({category,month,amount}) {

   const data= {
      series: category,
      options: {
        chart: {
          height: 350,
          type: "area",
          group: "social",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [2, 2],
          colors: ["#9568ff", "#709fba","orange","red","orange","blue"],
          curve: "smooth",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
          markers: {
            fillColors: ["#9568ff", "#709fba","orange","red","orange","blue"],
            width: 19,
            height: 19,
            strokeWidth: 0,
            radius: 19,
          },
        },
       
        xaxis: {
			categories: month
        },
        yaxis: {
          labels: {
            style: {
              colors: "#3e4954",
              fontSize: "14px",
              fontFamily: "Poppins",
              fontWeight: 100,
            },
            formatter:function (val) {
                return (val / 1000).toFixed(2) + 'k';
              }
          },
        },
        fill: {
          colors: ["#9568ff", "#709fba","orange","red","orange","blue"],
          type: "solid",
          opacity: 0.07,
        },
        grid: {
          borderColor: "#f1f1f1",
        },
      },
    };
  


  return (
       <div id="chart" className="line-chart-style bar-chart">
        <ReactApexChart
          options={data.options}
          series={data.series}
          type="area"
          height={300}
        />
      </div>
  )
}
